import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
    Autocomplete, Button, Cell, DataTable, Grid,

    TableBody,

    TableColumn, TableHeader,Divider,

    TableRow,TablePagination,DialogContainer,DatePicker,TimePicker, TextField
} from 'react-md';
import Moment from 'moment';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import CollapsableColumn from '../component/CollapsableColumn';
import '../css/Dashboard.css';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router';
import MomentTz from 'moment-timezone';
import { AppSetting, AppProperties } from '../common/function'
import "../css/loginAttempt.css"
import Fuse from 'fuse.js';
import SearchIcon from '../images/png/searchIcon.png'
import CancelIcon from  '../images/png/cancel.png'
import StarIcon   from  '../images/png/Star.png'

import { PronounList } from "../common/function"
const LoginAttemptPage = (props) => {
   const appSetting = AppSetting();
   const appProperties = AppProperties();

    const [startTimeStamps,setStartTimeStamps] = useState([])
    const [endTimeStamps,setEndTimeStamps] = useState([])
    const [quizId,setQuizId] = useState([])
    const [students,setStudents] = useState([])
    const [studentSearchByID,setStudentSearchByID] = useState("")
    const [studentSearchByName,setStudentSearchByName] = useState("")
    const [loading,setLoading] = useState(false)
    const [currentUserId,setCurrentUserId]= useState("")
    const [locksHistory,setLocksHistory] = useState([])
    const [extendHistory,setExtendHistory] = useState([])
    const [showLoginAttemptTable,setShowLoginAttemptTable] = useState(false)
    const [showViewAssignmentsTable,setShowViewAssignmentsTable] = useState(false)
    const [quizList,setQuizList] = useState([])
    const [quizData,setQuizData] = useState([])
    const [dueDatePage,setDueDatePage] = useState(false)
    const [selectedQuizId,setSelectedQuizId] = useState("")
    const [assignStartDate,setAssignStartDate] = useState("")
    const [assignEndDate,setAssignEndDate] = useState("")
    const [studentQuizDetails,setStudentQuizDetails] = useState(false)
    const [questionShowed,setQuestionShowed] = useState([])
    const [questionDataQuizId,setQuestionDataQuizId] = useState("")
    const [searchKeywordQuizName,setSearchkeywordQuizName] =  useState("")
    const [currentTimeZone,setCurrentTimeZone] = useState("")
    const [CurrentStuExtendDueDate,setCurrentStuExtendDueDate] = useState([])
    const [quizName ,setQuizName] = useState([])
    const [showMoreLoginAttempt ,setShowMoreLoginAttempt] = useState(false)
    const [showMoreCourseName ,setShowMoreCourseName] = useState(false)


    const [userNameIndexer, setUserNameIndex] = useState(new Fuse([]))
    const [studentNameIndexer, setStudentNameIndexer] = useState(new Fuse([]))
    const [studentData,setStudentData] = useState({})
    const [currentStudentData,setCurrentStudentData] = useState({})
    const [showStudentData,setShowStudentData] = useState(false)
    const [showNextUserDemo ,setShowNextUserDemo] = useState(2)
    const [csvHeader, setCsvHeader] = useState([
        { label: "User id", key: "user_id" },
        { label: "Assignment id", key: "quiz_id" },
        { label: "Subject id", key: "subject_id" },
        { label: "Topic id", key: "topic_id" },
        { label: "Category id", key: "category_id" },
        { label: "Subcategory id", key: "subcategory_id" },
        { label: "Question id", key: "question_id" },
        { label: "Question start time", key: "question_start_time" },
        { label: "Question end time", key: "question_end_time" },
        { label: "Question Attempt", key: "question_attempt" },
        { label: "Assignment Attempt", key: "quiz_attempt" },
        { label: "Answer Type", key: "answer_type" },
        { label: "Is Answer Correct", key: "is_answer_correct" },
    ])
     const [csvTestHeader, setCsvTestHeader] = useState([
        { label: "User id", key: "user_id" },
        { label: "Assignment id", key: "quiz_id" },
        { label: "Course id", key: "course_id" },
        { label: "Section id", key: "section_id" },
        { label: "Subsection id", key: "subsection_id" },
        { label: "Question id", key: "question_id" },
        { label: "Question Answer id", key: "question_answer_id" },
        { label: "Last Answer Time", key: "last_answer_time" },
        { label: "Subject id", key: "subject_id" },
        { label: "Topic id", key: "topic_id" },
        { label: "Category id", key: "category_id" },
        { label: "Subcategory id", key: "subcategory_id" },
        { label: "Non Graded Question Count", key: "non_graded_question_count" },
    ])
    const settingsTimeZone = appProperties.currentUserData.timeZone || 'America/New_York'
    useEffect(()=>{
        setLoading(true);
        getTimeZone()
        getAllStudents()
        setLoading(false);

    },[])

    useEffect(()=>{
        setQuizData(quizList.slice(0,20))
    },[quizList,locksHistory,extendHistory])
    
    useEffect(()=> {
      let locksData = locksHistory.locksDetails
      let extendData = extendHistory.student_extendHistory
      let studentQuizData = quizList
      if(studentQuizData?.length > 0 && extendData?.length > 0 ) {
        for(let quiz of studentQuizData) {
          for(let extend of extendData) {
           if (quiz.quiz_id == extend.quiz_id) {
             quiz.extendCount = extend.extend_count
             quiz.extendTimeStamp = extend.extend_timestamp
             quiz.extendDetails = extend
           }
          }
        }
      }

      if(studentQuizData?.length > 0 && locksData?.length > 0 ) {
        for(let quiz of studentQuizData) {
          for(let locks of locksData) {
           if (quiz.quiz_id == locks.quiz_id) {
             quiz.releaseCount = locks.release_count
             quiz.locksTimeStamp = locks.locks_timestamp
             quiz.releaceDetails = locks
           }
          }
        }
      }

    
      setQuizList(studentQuizData)
    },[locksHistory,quizList,quizData,extendHistory])

    const getLocksHistory = () => {
      setLoading(true)
  
      const payload = {            
        student_id:currentUserId    
      };
  
      ApiRequestService({
        url:'/locksHistory',
        method:'post',
        data: payload
      }).then(res => {
  
        if(res.data !== undefined && res.data !== null &&
            res.data.data !== undefined && res.data.data !== null){
            if(res.data.status === 0){
              let locksData = res.data.data
                setLocksHistory(locksData)
                setLoading(false)                    
                }else{
                    NotificationManager.error("error",res.data.message,5000);
                }
            }else{
                NotificationManager.error("Error in Retriving Student Release Locks");
            }
    }).catch(error => {
        NotificationManager.error("Get Students Failed  : "+error,"ERROR",2000)
    });
    setLoading(false)
    }
    const getTimeZone = () =>{
      let timeZone = window.localStorage.getItem(`${appSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`)
      setCurrentTimeZone(timeZone)
  }
    const filterUserName = (data, filterText, dataLabel) => {
      let newFilteredStudents = userNameIndexer?.search(filterText).map((res, index) => {
        return {...res.item, key: `${res.item?.user_name}_${index}`}
      });
      return newFilteredStudents;
    };

    const filterStudentName = (data, filterText, dataLabel) => {
      let newFilteredStudents = studentNameIndexer?.search(filterText).map((res, index) => {
        return {...res.item, key: `${res.item?.user_name}_${index}`}
      });
      return newFilteredStudents;
    };
 
    const getAllStudents = () =>{
        setLoading(true)
        console.debug("in getAllStudents")
        ApiRequestService({
                url:'/getAllStudents',
                method:'post'      
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                      let StudentsData = res.data.data
                      let userNameFuse = new Fuse(StudentsData, {
                        isCaseSensitive: false,
                        includeScore: true,
                        shouldSort: true,
                        minMatchCharLength: 2,
                        threshold: 0.1,
                        keys: [{ name: 'user_name', }]
                      });
                      let studentNameFuse = new Fuse(StudentsData, {
                        isCaseSensitive: false,
                        includeScore: true,
                        shouldSort: true,
                        minMatchCharLength: 2,
                        threshold: 0.1,
                        keys: [{ name: 'student_name', }]
                      });
                      setUserNameIndex(userNameFuse)  
                      setStudentNameIndexer(studentNameFuse)
                        setStudents(StudentsData)
                        setLoading(false)
                         console.debug("in getAllStudents",res.data)                         
                        }else{
                            NotificationManager.error("error",res.data.message,5000);
                        }
                    }else{
                        NotificationManager.error("No Student Found");
                    }
            }).catch(error => {
                NotificationManager.error("Get Students Failed  : "+error,"ERROR",2000)
            });
            setLoading(false)
    }

    const searchByQuizname = () => {
      let filteredQuizList =[]
      let filteredQuizName = 
      quizList.filter((quiz) => {
        return quiz.quiz_name.toLowerCase().match(searchKeywordQuizName.toLowerCase());
      });
      let filteredQuizID = 
      quizList.filter((quiz) => {
        return quiz.quiz_id == searchKeywordQuizName;
      });
      filteredQuizList =[...filteredQuizID,...filteredQuizName]
      setQuizData(filteredQuizList)
    }
    const getStudentStatus = (userID) => {
        setLoading(true)

        if(userID === ''){
            NotificationManager.error("Please select a student");
            setLoading(false)
            return
        }
        const payload = {
            user_name: userID
          };

          ApiRequestService({
            url:'/getStudentStatus',
            method:'post',
            data:payload, 
        }).then(res => {

            if(res.data !== undefined && res.data !== null &&
                res.data.data !== undefined && res.data.data !== null){
                    const studentData = res.data.data
                    if( studentData !== null && quizData !== undefined) {
                      setStudentData(studentData)
                      setShowStudentData(true)
                    }
                    setLoading(false)
                
            } else {
              NotificationManager.error("No Students(s) Found");
              setLoading(false)
            }
        })
         
    }
    const getStudentQuizList = () => {
      if(showLoginAttemptTable) {
      setShowLoginAttemptTable(false)
      }
        setLoading(true)

        if(currentUserId === ''){
            NotificationManager.error("Please Select a Student");
            setLoading(false)
            //setShowLoginAttemptTable(false)
            return
        }
        const payload = {
            user_name: currentUserId,
            includeLTI: true,
          };
          // console.log("payload",payload)

          ApiRequestService({
            url:'/getQuizStudentDashboard',
            method:'post',
            data:payload, 
        }).then(res => {

            if(res.data !== undefined && res.data !== null &&
                res.data.data.data !== undefined && res.data.data.data !== null){
                    // console.log("res.data.data",res.data.data)
                    const quizlistdata = res.data.data.data
                    if( quizlistdata !== null && quizData !== undefined) {
                      setShowViewAssignmentsTable(true)
                      setQuizList(quizlistdata)
                    }

                    getLocksHistory()
                    getExtendHistory()
                    setLoading(false)
                
            } else {
              NotificationManager.error("No Assignment(s) Found");
              setShowViewAssignmentsTable(false)
              setQuizList([])
              setLoading(false)
            }
        })
         
    }
    const isValidDate = function(d) {
      return d instanceof Date && !isNaN(d);
    }
    const handleExtendDuedate = (courseDetail,index) => {
      setSelectedQuizId(courseDetail.quiz_id)
      setDueDatePage(true)
      getStudentQuizTime(courseDetail)
    }
    const quizHandlePagination =(start, rowsPerPage) => {
        let sampleQuizlist = quizList
          setQuizData(sampleQuizlist.slice(start,start + rowsPerPage))
    }

    const updateVisibleHide = () => {
      setDueDatePage(false)
      setAssignStartDate('')
      setAssignEndDate('')
      setCurrentStuExtendDueDate([])
    }

    const handleStudentEndDate = (timeString, sDate, event) => {
      if (sDate !== null) {
        
        setAssignEndDate(sDate)
      }
    }
    const handleStudentStartDate = (timeString, sDate, event) => {
      
      if (sDate !== null) {
        setAssignStartDate(sDate)
      }
    }
    const saveStudentQuizTime = () => {
    
      
      if(currentUserId === null || currentUserId === ""){
          NotificationManager.error('Please enter vaild student name', 'ERROR', 3000);
          return;
      }
      
      if(assignStartDate === null || assignStartDate ===""){
          NotificationManager.error('Please enter vaild Start Date and time', 'ERROR', 3000);
          return;
      }
      if(assignEndDate === null || assignEndDate === ""){
          NotificationManager.error('Please enter vaild end Date and time', 'ERROR', 3000);
          return;
      }
      let quizID = parseInt(selectedQuizId, 10);
      if(quizID === null &&  quizID === 0 ){
        NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
        return;
      }
      
      
      var tempStartDate = moment(assignStartDate).format('YYYY/MM/DD HH:mm');
      var tempEndDate = moment(assignEndDate).format('YYYY/MM/DD HH:mm');
      const payload = {      
        student_id:currentUserId,
        quiz_id:quizID,
        student_start_time:tempStartDate,
        student_end_time:tempEndDate
      };
      // console.log("payload",payload);
  
      ApiRequestService({
        method: 'post',
        url: '/saveStudentQuizTime',
        data:payload
      }).then(res => {
        // console.log("saveStudentQuizTime",res)
        NotificationManager.success('Saved successfully', 'Success', 3000);
        updateVisibleHide();
        getExtendHistory()
      });
    }
    const getExtendHistory = () => {
      setLoading(true)
  
      const payload = {            
        student_id:currentUserId    
      };
  
      ApiRequestService({
        url:'/getStudentExtendHistory',
        method:'post',
        data: payload
      }).then(res => {
  
        if(res.data !== undefined && res.data !== null &&
            res.data.data !== undefined && res.data.data !== null){
            if(res.data.status === 0){
              let ExtendData = res.data.data
                setExtendHistory(ExtendData)
                setLoading(false)                    
                }else{
                    NotificationManager.error("error",res.data.message,5000);
                }
            }else{
                NotificationManager.error("Error in Retriving Student Release Locks");
            }
    }).catch(error => {
        NotificationManager.error("Get Students Failed  : "+error,"ERROR",2000)
    });
    setLoading(false)
    }
    const updateStudentDetails = () => {
      if(currentUserId === null || currentUserId === ""){
          alert('Please enter vaild student name');
          return;
      }
      
      if(assignStartDate === null || assignStartDate === ""){
          NotificationManager.error('Please enter vaild Start Date and time', 'ERROR', 3000);
          return;
      }
      if(assignEndDate === null || assignEndDate === ""){
          NotificationManager.error('Please enter vaild end Date and time', 'ERROR', 3000);
          return;
      }
      
  
      // console.log("studentStartDate",assignStartDate);
      // console.log("studentEndDate",assignEndDate);
      // console.log("studentID",currentUserId);
  
      
      let quizID = parseInt(selectedQuizId, 10);
      
      if(quizID === null &&  quizID === 0 ){
        NotificationManager.error('Assignment id is not vaild', 'ERROR', 3000);
        return;
      }
      
      
      var tempStartDate = moment(assignStartDate).format('YYYY/MM/DD HH:mm');
      var tempEndDate = moment(assignEndDate).format('YYYY/MM/DD HH:mm');
      
      //get studentQuizTime ID
      let StudentQuizTimeID 
      let tempExtenDate = CurrentStuExtendDueDate;
      let tempStu = tempExtenDate?.forEach((stu) => {
        if (stu.quiz_id === quizID) {
          StudentQuizTimeID = stu.student_quiz_time_id;
        }
      });
      const payload = {      
        student_id:currentUserId,
        quiz_id:quizID,
        student_start_time:tempStartDate,
        student_end_time:tempEndDate,
        student_quiz_time_id:StudentQuizTimeID
      };
      
  
      ApiRequestService({
        method: 'post',
        url: '/updateStudentQuizTime',
        data:payload
      }).then(res => {
        NotificationManager.success('Update successfully', 'Success', 3000);
        updateVisibleHide();
      });
  
    }
    const getStudentQuizTime = (quizDetail) => {
      console.debug("getStudentQuizTime = ");
      setLoading(true)
      let quizID = quizDetail.quiz_id
      if(quizID != null){
        const payload = {            
          quiz_id:quizID,  
          student_id:currentUserId    
        };
  
        ApiRequestService({
          method: 'post',
          url: '/getStudentQuizTime',
          data:payload
        }).then(res => {
          setLoading(false)
          console.debug("Response = ",res);
          
          let studentQuizTimeList = res.data.data
          if (studentQuizTimeList.student_quiz_time
            ) {
            studentQuizTimeList.student_quiz_time.map((quiz) => {
              if(quiz.quiz_id === quizID){
                let studentStartDateLocal = new Date(quiz.student_start_time)
                let studentEndDateLocal =  new Date(quiz.student_end_time)
                studentStartDateLocal.setMinutes(studentStartDateLocal.getMinutes() + studentStartDateLocal.getTimezoneOffset())
                studentEndDateLocal.setMinutes(studentEndDateLocal.getMinutes() + studentEndDateLocal.getTimezoneOffset())
                setAssignStartDate(studentStartDateLocal)
                setAssignEndDate(studentEndDateLocal)
                setStudentQuizDetails(true)
              }
            }) 
            setCurrentStuExtendDueDate(studentQuizTimeList.student_quiz_time)
          }
          if(res.data.data.student_quiz_time === null ){
            setStudentQuizDetails(false)
          }
          setDueDatePage(true)

          // console.log("getStudentQuizTime res",studentQuizTimeList)
        });
      }
    }
    const getAllQuestionsShowed = (quiz) => {
        setLoading(true)
        if (!(!!quizId)) {
            NotificationManager.error("Please Enter the Assignment Id");
            setLoading(false)
            return;
        }
        setQuestionDataQuizId(quiz.quiz_id)
        const payload = {
            userId: currentUserId,
            quizId: quiz.quiz_id
        };

        if(quiz.quiz_type == 1) {

          ApiRequestService({
              url: '/getAllQuestionsShowedByForTestQuizID',
              method: 'post',
              data: payload
          }).then(res => {
              // console.log('ApiRequestService', res)
              const { data, status } = res.data;
             
              if (data !== undefined && data !== null) {
              
                  if (status === 0) {
                      if (data.QuizList !== undefined && data.QuizList !== null) {
                          setQuestionShowed(data.QuizList)
                      } else {
                          setQuestionShowed([])
                          NotificationManager.error("No Questions Found");
                      }
                  } else {
                      setQuestionShowed([])
                      NotificationManager.error("error", data.message, 5000);
                  }
              } else {
                  if (data.message === 'No Access') {
                      NotificationManager.error("You have No access to check Questions Showed. Please contact admin.");
                      setQuestionShowed([])
                      setLoading(false)
                  } else {
                      setQuestionShowed([])
                      NotificationManager.error("No Questions Found");
                  }
              }
          }).catch(error => {
              setQuestionShowed([])
              NotificationManager.error("Get Questions Showed Failed!", "ERROR", 2000)
          });

        } else {

          ApiRequestService({
              url: '/getAllQuestionsShowedByQuizID',
              method: 'post',
              data: payload
          }).then(res => {
              // console.log('ApiRequestService', res)
              const { data, status } = res.data;
             
              if (data !== undefined && data !== null) {
                
                  if (status === 0) {
                      if (data.QuizList !== undefined && data.QuizList !== null) {
                        //timezone fix
                        for (let quiz of data.QuizList) {
                          let StartTimeoffset = moment.tz(quiz.question_start_time, settingsTimeZone).utcOffset();
                          let EndTimeoffset = moment.tz(quiz.question_end_time, settingsTimeZone).utcOffset()
                          quiz.question_start_time = moment(quiz.question_start_time).add(StartTimeoffset, 'minutes').format('YYYY-MM-DD HH:mm:ss.S');
                          quiz.question_end_time = moment(quiz.question_end_time).add(EndTimeoffset, 'minutes').format('YYYY-MM-DD HH:mm:ss.S');
                        }
                          setQuestionShowed(data.QuizList)
                      } else {
                          setQuestionShowed([])
                          NotificationManager.error("No Questions Found");
                      }
                  } else {
                      setQuestionShowed([])
                      NotificationManager.error("error", data.message, 5000);
                  }
              } else {
                  if (data.message === 'No Access') {
                      NotificationManager.error("You have No access to check Questions Showed. Please contact admin.");
                      setQuestionShowed([])
                      setLoading(false)
                  } else {
                      setQuestionShowed([])
                      NotificationManager.error("No Questions Found");
                  }
              }
          }).catch(error => {
              setQuestionShowed([])
              NotificationManager.error("Get Questions Showed Failed!", "ERROR", 2000)
          });
        }
        setLoading(false)
    }
 const releaseLocks = (courseDetail,index) => {
   
   let quizID = parseInt(courseDetail.quiz_id, 10);
   const payload = {      
                     student_id:[currentUserId],
                    quiz_id:quizID
                    };

    ApiRequestService({
      method: 'post',
      url: '/releaseLocks',
      data:payload
    }).then(res => {
      if(res?.data?.data)  {
        getLocksHistory()
        return NotificationManager.success('Lock Released successfully', 'Success', 3000);
      }
      return NotificationManager.error('Lock Released failed!', 'ERROR', 3000);
    });
   
  }
    const getLoginAttempt = (userID) =>{
        setLoading(true)
        if(showViewAssignmentsTable) {
            setShowViewAssignmentsTable(false)
        }
        if(userID === ''){
            NotificationManager.error("Please Select a Student");
            setLoading(false)
            //setShowLoginAttemptTable(false)
            return
        }
        const payload = {
            userId: userID
          };

        ApiRequestService({
                url:'/getLoginAttempts',
                method:'post',
                data: payload
              }).then(res => {

                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        if(res.data.data.startTimeStamps !== undefined && res.data.data.startTimeStamps !== null){
                            setStartTimeStamps(res.data.data.startTimeStamps)
                            if(res.data.data.endTimeStamps !== undefined && res.data.data.endTimeStamps !== null){
                                setEndTimeStamps(res.data.data.endTimeStamps)
                            }
                            if(res.data.data.quizId !== undefined && res.data.data.quizId !== null){
                                setQuizId(res.data.data.quizId)
                            }
                            setQuizName(res?.data?.data?.quizName)
                            setShowLoginAttemptTable(true)
                            setLoading(false)
                        }else{
                            NotificationManager.error("No Login Attempts Found");
                            setStartTimeStamps([])
                            setEndTimeStamps([])
                            setQuizId([])
                            setQuizName([])
                        }  
                    }else{
                        NotificationManager.error("error",res.data.message,5000);
                    }
                    }else{
                        if(res.data.message === 'No Access'){
                            NotificationManager.error("You have No access to check Login Attempt. Please contact admin.");
                            setLoading(false)
                            setShowLoginAttemptTable(false)
                        }else{
                            NotificationManager.error("No Login Attempts Found");
                        }
                    }
            }).catch(error => {
                NotificationManager.error("Get Login Attempts Failed  : "+error,"ERROR",2000)
            });
            setLoading(false)
    }

    const handleOnAutoCompleteByID = (args) =>{
        setShowLoginAttemptTable(false)
        setShowViewAssignmentsTable(false)
        setQuestionShowed([])
        setLocksHistory([])
        setExtendHistory([])
        let tempCurrentMatches = args[2]
        console.debug("in handleOnAutoComplete",args,args[2],tempCurrentMatches[args[1]])
        setCurrentUserId(tempCurrentMatches[args[1]]?.user_name)
        setStudentSearchByID(tempCurrentMatches[args[1]]?.full_name_user_id)
        getStudentStatus(tempCurrentMatches[args[1]]?.user_name)
        setStudentSearchByName("")
        setCurrentStudentData(tempCurrentMatches[args[1]])
        getLoginAttempt(tempCurrentMatches[args[1]]?.user_name);
      
    }

    const handleOnAutoCompleteByName = (args) =>{
    
        setShowLoginAttemptTable(false)
        setShowViewAssignmentsTable(false)
        setQuestionShowed([])
        let tempCurrentMatches = args[2]
        console.debug("in handleOnAutoComplete",args,args[2],tempCurrentMatches[args[1]])
        setCurrentUserId(tempCurrentMatches[args[1]]?.user_name)
        setStudentSearchByID("")
        getStudentStatus(tempCurrentMatches[args[1]]?.user_name)
        setStudentSearchByName(tempCurrentMatches[args[1]]?.full_name_user_id)
        setCurrentStudentData(tempCurrentMatches[args[1]])
        getLoginAttempt(tempCurrentMatches[args[1]]?.user_name);
    
    }

    const handleMoreLoginAttempt=() =>{
       setShowMoreLoginAttempt(!showMoreLoginAttempt)
    }

    const handleMoreCourseName=() =>{
       setShowMoreCourseName(!showMoreCourseName)
   }
    const handleStudentStatus =() =>{
      const payload = {
        user_name: currentUserId
      };
  
      ApiRequestService({
        url:'/changeStudentActiveStatus',
        method:'post',
        data: payload
      }).then(res=>{
        if(res.data.message === 'success') {
          const updatedStudentData = {
            ...studentData,
            isActive: 'Active', 
          };
          setStudentData(updatedStudentData)
          NotificationManager.success("Student activated")
        }else{
          NotificationManager.error("Error while activating student")
        }
      })
    }
    const handleResetPassword =()=>{
      const payload = {
        user_name: currentUserId
      };
      ApiRequestService({
        url:'/setPassword',
        method:'post',
        data: payload
      }).then(res=>{
        if(res.data?.message ==="success"){
          NotificationManager.success("The password has been successfully reset.")
        }else{
          NotificationManager.error("The password reset attempt has failed.")
        }
       
      });
    }
   const handleNextStep =(val)=>{
      setShowNextUserDemo(val)
   }
  const formatTime =(time)=>{
      const startTime = new Date(time);
    
      let hour = startTime.getHours();
      const ampm = hour >= 12 ? 'pm' : 'am';
      hour = hour % 12;
      hour = hour ? hour : 12; // Handle midnight

      // Format the date components
      const year = startTime.getFullYear().toString().slice(-2); // Get last two digits of the year
      const month = ('0' + (startTime.getMonth() + 1)).slice(-2); // Add leading zero if needed
      const day = ('0' + startTime.getDate()).slice(-2); // Add leading zero if needed
      const minute = ('0' + startTime.getMinutes()).slice(-2); // Add leading zero if needed

      // Create the formatted time string
      const formattedTime = `${month}.${day}.${year} ${hour}:${minute}${ampm}`;

      return formattedTime
  }

   const getTimeInterval =(startTimeData,endTimeData)=>{
      const startTime = new Date(startTimeData);
      const endTime = new Date(endTimeData);

      const timeDifferenceMs = endTime - startTime;

      const timeDifferenceMinutes = Math.floor(timeDifferenceMs / (1000 * 60));
      const formatTimeStr = `${timeDifferenceMinutes}min`
      return formatTimeStr
   }

   function SkeletonAnimation() {
    return (
      <div className="skeleton-container" style={{ width :'100%'}}>
         <Grid style={{margin:'0'}} gutter={2} spacing={1}>
                        <Cell size={12} style ={{ width:"100%"}}>
                          <Grid
                            gutter={3}
                            className=" noMarigin styleScoreDistribution noHorizondalPadding noTopPadding  assignment_table_animation" 
                          >
                            <Cell size={12} style={{display:"flex",justifyContent:"space-between",height :'50px'}} className=''>
                              <Cell size={5} phoneSize={12} className="noLineHeight assignment_table_animation_row">
                              </Cell>
                              <Cell  size={4} className='skeleton assignment_table_animation_row'  >
                              </Cell>
                            </Cell>
                            <Cell size={12} className="noMarigin fullWidth   skeleton ">
                              <Divider className="fullWidth" />
                            </Cell>
                            { [1,2,3,4,5,6,7].map((i )=>{
                              return (
                                <>
                                <Cell size={12} style={{display:"flex",justifyContent:"space-between",height :'50px'}} className=''>
                                {[1,2,3,4,5,6,7,8,9,10,11].map((i) =>{
                                  return(
                                    <>
                                     <Cell key={i} className=''>
                                      <div 
                                      className='assignment_table_animation_column'
                                      ></div>
                                     </Cell>
                                    </>
                                   
                                  )
                                })}
                              </Cell>
                                </>
                              )
                            })}
                          </Grid>
                        </Cell>
                      </Grid>
      </div>
    );
  }

    const rows = quizList?.length
    // targetRole refers to role_weight
    return  <SecureShow targetRole={1} > 
                <Grid gutter={1} className="gradeBookPageContainer">
                  {(showNextUserDemo !== 2) ?
                  <Cell size={12} style={{marginLeft:'2px'}}>          
                   <Cell size={12} style={{height:'29px'}} >
                        <h1 className = "md-text--theme-primary" style = {{fontSize: '26px',fontWeight:700,marginLeft:'26px',marginTop:'26px'}}>
                        Students
                        </h1>
                    </Cell>
                    <Cell size={12} >
                        <h4 className = "md-text" style = {{fontSize: '12px',fontWeight:400,marginLeft:'26px',marginTop:'8px',color:'#A7B1B7',fontStyle: "italic"}}>
                         Manage profiles, View Enrollments & Assignments
                        </h4>
                    </Cell>
                    <Cell size={12} style={{marginLeft:'26px'}} style={{borderRadius:"3px"}}>
                    <Cell size={12}  className={"Search-Student-Demo"} >
                        <Cell size={12} style={{height:"40px"}} >
                        <h2 className = "md-text" className={'Search-Student-Header'}>
                        Search for a Student to get started
                        </h2>
                    </Cell>
                    <Cell size={12} style={{height:"44px",maxWidth:"710px"}} >
                        <h4 className = "md-text" style = {{color:"#2E7FA1",fontWeight:400,fontSize:"13px",marginLeft:'40px',marginTop:'1px',paddingTop:'16px',maxWidth:'712px'}}>
                        Start typing in one of the below boxes and you would see a drop-down listing the matching students(registered already). 
                         If you don’t see a drop-down, please ask the user to sign-up first.
                        </h4>
                    </Cell>
                    <Cell size={12} style={{display:'flex',alignItems:'center',justifyContent:'center',paddingTop:'24px'}} >
                         <Cell size={12} style={{width:"60%",border:'1px solid #646A6E',borderRadius:'25px',background:'#A7B1B7',height:'50px'}}  >
                         <Cell size={12} style={{display:'flex',alignItems:'center',height:'80%'}}>
                              <Cell>
                            <h2 className = "md-text" style = {{color:"#FFFFFF",fontWeight:700,fontSize:"12px",marginTop:'4px',display:'flex',alignItems:'center',width:'80px',fontStyle:"italic"}}>
                            Search By
                            
                            </h2>
                            </Cell>
                        <Cell style={{width:'100%',height:'33px'}}>
                          <input style={{width:'100%',height:'33px',borderRadius:'15px',border:'0px',paddingLeft:'16px',marginTop:'-4px', background:'white'}}
                           placeholder="User ID" disabled
                          />

                        </Cell>
                        <Cell style={{width:'100%',height:'33px'}}>
                          <input  style={{width:'100%',height:'33px',borderRadius:'15px',border:'0px',paddingLeft:'16px',marginTop:'-4px', background:'white'}}
                           placeholder="First Name/Last Name" disabled
                          />
                            
                        </Cell>
                          </Cell>
                          </Cell>
    
                    </Cell>

                    </Cell>
                    </Cell> 
                    </Cell>:""}
                    {showNextUserDemo == 0 ?<Cell size={12}>
                      <center><Button style={{width:'309px',background:'#A7B1B7',height:'38px',color:'#FFFFFF',fontSize:'16px',fontWeight:'800'}}
                        onClick={()=>handleNextStep(1)}
                      >What happens next?</Button></center>
                      </Cell> :""}
                     {showNextUserDemo == 1 ? <Cell size={12} style={{marginLeft:'10px'}}>
                        <Cell  size={12} style={{height:"230px",backgroundColor:"#C6E9F8"}}>
                        <Cell size={12} style={{height:"40px"}} >
                        <h2 size={12} className = "md-text" style = {{color:"#2E7FA1",fontWeight:600,fontSize:"20px",marginLeft:'26px',marginTop:'1px',paddingTop:'16px'}}>
                        Then, you’re going to see the student information like this
                        </h2>
                        <Cell size={12} style={{height:"44px",maxWidth:"710px"}} >
                        <h4 className = "md-text" style = {{color:"#2E7FA1",fontWeight:400,fontSize:"12px",marginLeft:'26px',marginTop:'1px',width:'712px'}}>
                        You can use the available buttons to perform further actions. 
                        </h4>
                    </Cell>
                    <Cell size={12} style={{height:"99px",background:'#FFFFFF',borderRadius:'10px',display:'flex',justifyContent:'flex-start'}}>
                     <Cell size={12} style={{width:"5%",height:'85%',display:'flex',justifyContent:'center',alignItems:'center'}} >
                            <Cell size={12}  style={{background:"#A7B1B7",width:'26px',height:'26px',borderRadius:'50%'}}>
                            </Cell>
                     </Cell>
                     <Cell style={{width:'20%'}} >
                        <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:700,fontSize:"16px",marginLeft:'26px',height:'10px'}}>
                          Student Name
                        </h2>
                        <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px'}}>
                          Pronoun
                        </h2>
                        <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px'}}>
                          Username
                        </h2>
                     </Cell>
                     <Cell style={{display:'flex',alignItems:'end'}}>
                          <Cell style={{flex:'1'}}>

                         
                          <Cell  style={{height:"28px",borderRadius:'15px',background:'#A7B1B7',width:"110.73px"}}>
                          </Cell>
                          </Cell>
                          <Cell style={{flex:'1'}}>
                          <Cell style={{height:"28px",borderRadius:'15px',background:'#A7B1B7',width:"110.73px"}}>
                          </Cell>
                          </Cell>
                     </Cell>
                     <Cell>
                     <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:600,fontSize:"12px",marginLeft:'26px',height:'10px'}}>
                       Course/Section Enrollments
                        </h2>
                        <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px'}}>
                        No Course/Section Enrollments yet
                        </h2>
                      </Cell>
                      <Cell  style={{position:'relative'}}>
                      <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px',position:'absolute',bottom:'0',right:'0'}}>
                        Sign up/ Login Timestamp
                        </h2>
                      </Cell>
                    </Cell>
                    </Cell>
                        </Cell>
                      </Cell>:""}
                    {showNextUserDemo == 1 ? <Cell size={12}>
                      <center><Button style={{width:'309px',background:'#A7B1B7',height:'38px',color:'#FFFFFF',fontSize:'16px',fontWeight:'800'}}
                        onClick={() =>handleNextStep(2)}
                      >Ok, got it. Thanks!</Button></center>
                      </Cell>:"" } 

                      { showNextUserDemo == 2 ?
                      <Cell size={12} style={{marginLeft:'2px'}}>
                        <Cell size={12} style={{display:'flex',justifyContent:'space-between'}}>
                      <Cell size={12} style={{height:'29px',width:'36%'}} >
                        <h1 className = "md-text--theme-primary" style = {{fontSize: '26px',fontWeight:700,marginLeft:'26px',marginTop:'26px',color:'#000000',height:'20px'}}>
                        Students
                        </h1>
            
                        <h4 className = "md-text" style = {{fontSize: '12px',fontWeight:400,marginLeft:'26px',color:'#A7B1B7',height:'10px',fontStyle: "italic"}}>
                         Manage profiles, View Enrollments & Assignments
                        </h4>
          
                    </Cell>
                    <Cell size={12} style={{display:'flex',alignItems:'center',justifyContent:'center',paddingTop:'24px'}} >
                         <Cell size={12} style={{width:"100%",border:'1px solid #646A6E',borderRadius:'25px',background:'#A7B1B7',height:'60px'}}  >
                         <Cell size={12} style={{display:'flex',alignItems:'center'}}>
                          <cell>
                         <h2 className = "md-text" style = {{ color:"#FFFFFF",fontWeight:700,fontSize:"12px",marginTop:'4px',display:'flex',alignItems:'center',width:'70px'}}>
                         Search By
                         
                        </h2>
                        </cell>
                        <Cell style={{width:'50%',height:'33px'}}> 
                        <Autocomplete
                            autocompleteWithLabel
                            autoComplete='off'
                            style={{display:'flex',height:'33px',width:'100%',borderRadius:'15px',border:'0px',paddingLeft:'16px',marginTop:'-4px',background:'white'}}
                            id="user_name"
                            dataLabel='user_label'
                            dataValue='key'
                            className='UserIDSearchBar'
                            placeholder="Search by User ID"
                            onAutocomplete={(...args) => {
                                handleOnAutoCompleteByID(args)
                            }}
                            value={studentSearchByID}
                            onChange={(value) =>{
                             
                              setStudentSearchByID(value)
                            }}
                            rightIcon={
                               <div  className='SearchIcon' style={{width:'39px',height:'20px'}}><Button style={{width:'39px',height:'20px'}} onClick={()=>setStudentSearchByID("") }><img style={{paddingRight:'8px',cursor:'pointer',width:'22px',height:'15px'}} src={studentSearchByID.length ==0 ? SearchIcon :CancelIcon}></img></Button></div>
                            }
                            filter={filterUserName}
                            />                  
                        
                        </Cell>
                        <Cell style={{width:'50%',height:'33px'}}>
                        <Autocomplete
                            autocompleteWithLabel
                            autoComplete='off'
                            style={{display:'flex',height:'33px',width:'100%',borderRadius:'15px',border:'0px',paddingLeft:'16px',marginTop:'-4px',background:'white'}}
                            id="UserIDSearchBar"
                            className='UserIDSearchBar'
                            dataLabel = 'student_label'
                            dataValue='key'
                            placeholder="Search by First Name/Last Name"
                            onAutocomplete={(...args) => {
                                handleOnAutoCompleteByName(args)
                            }}
                            value={studentSearchByName}
                            onChange={(value) =>{
                              setStudentSearchByName(value)
                            }}

                            rightIcon={
                              <div  className='SearchIcon' style={{width:'39px',height:'20px'}} ><Button style={{width:'39px',height:'20px'}} onClick={()=>setStudentSearchByName("")}><img style={{paddingRight:'8px',cursor:'pointer',width:'22px',height:'15px'}} src={studentSearchByName.length ==0 ? SearchIcon :CancelIcon}></img></Button></div>
                           }
      
                            filter={filterStudentName}
                            />      
                
                        </Cell>
                          </Cell>
                          </Cell>
                    </Cell>
                    
                        </Cell>
                       { !(showStudentData) ? <Cell size={12}>
                        <Cell size={12} style={{background:'#FFF0CC',height:'50px',marginLeft:'26px',height:'100px',marginTop:'60px',display:'flex',justifyContent:'space-between',alignItems:'center',padding:"23px"}}>
                          <Cell size={12} style={{width:'60%',padding:'0.56rem',height:'85px'}}>
                        <h1 className = "md-text--theme-primary" style = {{fontSize: '20px',fontWeight:500,color:'#FFB600',height:'20px'}}>
                         No data to display yet
                        </h1>
            
                        <h4 className = "md-text" style = {{fontSize: '12px',fontWeight:400,color:'#FFB600',height:'10px'}}>
                        Search for a student in any of the above boxes to get started
                        </h4>
                        </Cell>
                        <Button style={{height:'35.25px', width:'192.58px', background:'#41B6E6',color:'#FFFFFF'}}
                          onClick={()=>setShowNextUserDemo(0)}
                        >See how this page works</Button>
                        </Cell>
                          </Cell>:""}
                      </Cell>:"" } 

                     { showStudentData ? <Cell size={12} className='StudentStatusBar'>
                      <Cell style={{flex:0.7,display:'flex'}}>
                              <Cell size={12} className='StudentStatus' whidth={"100%"} >
                                    <Cell size={12}  style={{background: studentData?.isActive ? "green":"#bb0000"}} className='StudentStatusContainer'>
                                    </Cell>
                            </Cell >
                            <Cell className='StudentStatusInfo'>
                            <h2 size={12} className="StudentStatusName md-text" >
                                { currentStudentData?.student_name}
                                </h2>
                            <Cell style={{display:'flex',width:'100%'}}>
                                  <Cell >
                                      {currentStudentData?.pronoun != 0 && <h2 size={12} className = "md-text" style = {{color:"#212325",fontWeight:300,fontSize:"11px",height:'10px'}}>
                                        {PronounList.find(pronoun => pronoun.value === currentStudentData?.pronoun)?.label}
                                      </h2>}
                                      <h2 size={12} className = "md-text" style = {{color:"#212325",fontWeight:300,fontSize:"11px",height:'10px'}}>
                                        {studentData?.user_name}
                                      </h2>
                                  </Cell>
                                  
                            <Cell style={{display:'flex',alignItems:'end',width:'20%',flex:1,justifyContent:'space-around',borderRight:"1px solid #A7B1B7",paddingRight:'30px'}}>
                                 { studentData?.isActive ? 
                                  <Cell >
                                  <Button size={8}  className='StudentStatusButton' onClick={getStudentQuizList} primary raised>View Assignments</Button>
                                  </Cell>
                                 :
                                  <Cell >
                                  <Button size={8}  className='StudentStatusButton' onClick={handleStudentStatus} primary raised>Activate Student</Button>
                                  </Cell>}
                                  <Cell >
                                  <Button   primary raised className='StudentStatusButton' style={{background:'#A7B1B7'}} onClick={handleResetPassword}>Reset Password</Button>
                                  </Cell>
                            </Cell>
                            </Cell>
                            <div style={{display:'flex',columnGap:'10px',marginLeft:'26px',minWidth:'195px',scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1',  overflowX: showMoreLoginAttempt ? 'auto' : 'hidden'}} >
                          
                            </div>
                            <div style={{ display :'flex',position :'relative'}}>
                              <h2 size={12} className = "md-text" style = {{color:"#212325",fontWeight:300,fontSize:"11px",height:'10px', whiteSpace :'nowrap',width:'430px',overflowX:'clip',marginLeft :'16px',marginTop :'-8px',scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1',  overflowX: showMoreCourseName ? 'auto' : 'clip', textOverflow: showMoreCourseName ? "hidden":'ellipsis'}}>
                                  {currentStudentData?.courseName}
                              </h2>  
                              {/* <button style={{position:'absolute',bottom:'9px',right:'0',border:'0',background:'#f9f9f9',fontWeight:'100',fontSize:'11px',cursor:'pointer'}}  onClick={handleMoreCourseName}>{ showMoreCourseName ? 'back' :'more ...' } </button> */}
                            </div>
                            </Cell>
                    </Cell>
                     <div className='verticalDivider'></div>
                     <Cell style={{flex:'1'}}>
                     <h2 size={12} className = "md-text" style = {{color:"#212325",fontWeight:700,fontSize:"16px",marginLeft:'26px',height:'10px'}}>
                        Login Attempts
                        </h2>
                       {quizId.length == 0 ?<h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px'}}>
                         No successful login attempts yet
                        </h2>
                        :<div style={{display:'flex',columnGap:'10px',marginTop:'30px',marginLeft:'26px',width:'96%',minWidth:'195px',minHeight :'73px',scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1',  overflowX: showMoreLoginAttempt ? 'auto' : 'hidden'}} >
                        {quizId.map((quiz,index)=>{
                          if (index > 3 && !showMoreLoginAttempt) return null
                          return(
                          <>
                          <div style={{display:'flex',flexDirection:'column',marginTop:'0.6rem',rowGap:'2px',minWidth:'195px',minHeight :'40px',borderRight:index !=3 ?'1px solid #DFE3E5':"0"}}>
                           <p style={{color:'#560319',fontWeight:'400',fontSize:'13px',textWrap:"nowrap",textOverflow:"ellipsis",overflow:"hidden"}}>{quiz} - {quizName[index]}</p>
                           <div>{formatTime(startTimeStamps[index])} <img src={StarIcon}></img> {getTimeInterval(startTimeStamps[index],endTimeStamps[index])}</div>
                           <div>{formatTime(endTimeStamps[index])} <img src={StarIcon}></img> {getTimeInterval(startTimeStamps[index],endTimeStamps[index])}</div>
                           {index ==2 ?  <button style={{position:'absolute',bottom:'14px',right:'0',border:'0',background:'#f9f9f9',fontWeight:'100',fontSize:'11px',cursor:'pointer'}}  onClick={handleMoreLoginAttempt}>{showMoreLoginAttempt ? 'back' :'more ...' } </button>:null}
                           </div>
                          </>
                        )})}
          
                        </div>}
                      </Cell>
                   
                     {/* {showMoreLoginAttempt ? <h2 size={12} className = "md-text" style = {{color:"#A7B1B7",fontWeight:300,fontSize:"11px",marginLeft:'26px',height:'10px',position:'absolute',bottom:'0',right:'0'}}>
                        Sign up/ Login Timestamp
                        </h2>:null} */}
                 

                      </Cell>:null}

               
                    
                    {showStudentData ? 
                      <div style={{
                        marginLeft:"3rem",
                      }}>NOTE: When you "Reset Password", new password will be <b>stemFluency@123</b>. Please email it to the student and they can change their password in the “Profile” page.</div>
                    : null}
                    {loading ?
                         <SkeletonAnimation />
                    :
                    // showLoginAttemptTable ?
                    //     <Cell size={12} >
                    //     <DataTable plain style={{width:'fit-content'}}>
                    //         <TableHeader style={{textAlignLast: 'center'}}>
                    //         <TableRow>
                    //         <TableColumn>Assignment ID</TableColumn>
                    //         <TableColumn>Login TimeStamp</TableColumn>
                    //         <TableColumn>Logout TimeStamp</TableColumn>
                    //         </TableRow>
                    //         </TableHeader>
                    //         <TableBody>
                    //         {startTimeStamps.map((startTimeStamp, i) => (
                    //             <TableRow key={i}>
                    //                 <TableColumn>{quizId[i]}</TableColumn>
                    //                 <TableColumn>{startTimeStamp}</TableColumn>
                    //                 <TableColumn>{endTimeStamps[i]}</TableColumn>
                    //             </TableRow>
                    //         ))}
                    //         </TableBody>
                    //     </DataTable>
                    //     </Cell>
                    //     :
                        showViewAssignmentsTable  ?
                        <Grid style={{margin:'0'}} gutter={2} spacing={1}>
                        <Cell size={12}>
                          <Grid
                            gutter={3}
                            className=" noMarigin styleScoreDistribution noHorizondalPadding noTopPadding"
                          >
                            <Cell size={12} style={{display:"flex",justifyContent:"space-between"}}>
                              <Cell size={5} phoneSize={12} className="noLineHeight">
                                <p style={{fontSize:"medium"}}>
                                Assignment List{' '} for {currentUserId}
                                  <div className="quizCount">{quizList.length}</div>
                                </p>
                                <span className="quizSubText">{false?"Current Academic Year":"Current Semester"}</span>
                              </Cell>
                              <Cell  size={4}>
                                {
                                    showViewAssignmentsTable  ?
                                    <div style={{display: 'flex'}}>
                                      <input style={{width: '73%'}} placeholder='Search By Quiz Name and Quiz ID' onKeyPress={(e) => e.key === 'Enter' && searchByQuizname() } 
                                      onChange={(event) => {
                                        if( event.target.value == '' ){
                                          if (quizList){
                                            setQuizData(quizList)
                                          }
                                        }
                                        setSearchkeywordQuizName(event.target.value)
                                      
                                      }
                                      }  type="search"/> 
                                      <Button style ={{marginLeft:'10px'}} primary 
                                      disabled={!quizList.length ? true : false}
                                      raised onClick={searchByQuizname}>Search</Button>
                                    </div>
                                    : ""
                                  }
                              </Cell>
                            </Cell>
                            <Cell size={12} className="noMarigin fullWidth">
                              <Divider className="fullWidth" />
                            </Cell>
                            <Cell size={12} phoneSize={12} className="noMarigin fullWidth">
                              <DataTable plain baseId="QuizTablePagination">
                                <TableHeader>
                                  <TableRow selectable={false}>
                                  <TableColumn className="quizTableHeaderColumn">
                                  Quiz Id
                                  </TableColumn>
                                    <TableColumn className="quizTableHeaderColumn">
                                    Quiz Name
                                    </TableColumn>
                                    <TableColumn className="quizTableHeaderColumn">
                                    Course
                                    </TableColumn>
                                    <TableColumn className="quizTableHeaderColumn">
                                      Section
                                    </TableColumn>
                
                                    <TableColumn className="quizTableHeaderColumn">
                                      Subsection
                                    </TableColumn>
                                    <TableColumn  style={{textAlign : "center"}}  className="quizTableHeaderColumn">
                                      Status
                                    </TableColumn>
                                    <TableColumn  style={{textAlign : "center"}}  className="quizTableHeaderColumn">
                                      Score
                                    </TableColumn>
                                    <TableColumn  style={{textAlign : "center"}}  className="quizTableHeaderColumn">
                                      Due Date
                                    </TableColumn>
                                    <TableColumn  style={{textAlign : "center",width:"10px"}}  className="quizTableHeaderColumn">
                                     Locks Released
                                    </TableColumn>
                                    <TableColumn  style={{textAlign : "center",width:"10px"}}  className="quizTableHeaderColumn">
                                      Due Extended
                                    </TableColumn>
                                    <TableColumn className="quizTableHeaderActionColumn">
                                      Actions
                                    </TableColumn>
                                  </TableRow>
                                </TableHeader>
                                <TableBody>
                                  {quizData.map((rowData, index) => (
                                    <TableRow selectable={false} key={index}>
                                      <TableColumn className="quizTableColumn">
                                        {rowData.quiz_id}
                                      </TableColumn>
                                      <TableColumn className="quizTableColumn">
                                        <Link style={{cursor:'pointer',textDecoration: "none"}} to={`QuizCreation?course_id=${parseInt(rowData.course_id)}&quiz_id=${parseInt(rowData.quiz_id)}&course_name=${rowData.quiz_name}`} target='_blank'>                                    
                                        {rowData.quiz_name}
                                        </Link>
                                      </TableColumn>
                                      <TableColumn className="quizTableColumn">
                                        {rowData.course_name}
                                      </TableColumn>
                
                
                                      <TableColumn className="quizTableColumn">
                                      {rowData.section_name}
                                        {/* {Moment(rowData.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")} */}
                                      </TableColumn>
                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                        {rowData.subsection_name}
                                      </TableColumn>
                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                      {rowData.finalscore_start_time ? "Attempted" : "Not Attempted"}
                                      </TableColumn>
                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                        {rowData.isScoreChanged ? rowData.editedScore : rowData.fullScoreIfAttempted && rowData.questionAttended > 0?
                                        (rowData.totalQuestion === rowData.questionAttended?
                                            100
                                            :  Math.round(parseFloat(rowData.questionAttended*100/rowData.totalQuestion)))
                                        :Math.round(parseFloat(rowData.completion_percentage))}
                                      </TableColumn>
                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                        {Moment(rowData.end_date,'DD/MM/YYYY').format("MM/DD/YYYY")}
                                      </TableColumn>
                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                        <div  className={ "Customtooltip"}>

                                        {rowData.releaseCount ? rowData.releaseCount : 0}

                                        {
                                          rowData?.locksTimeStamp?.length ? 
                                          <div class="tooltiptext">{
                                            rowData?.locksTimeStamp.map((stamp,index) => {

                                              return(
                                                <div style={{display:"flex",color:"white",padding:"5px"}}>
                                                    <div>{index + 1}. {moment.tz(stamp.updated_at,"UTC").format('MM/DD/YYYY HH:mm')}</div>
                                                   
                                                  </div>
                                              )
                                            })
                                          }</div>
                                          : " "
                                        }
                                        </div>
                                      </TableColumn>

                                      <TableColumn style={{textAlign : "center"}} className="quizTableColumn">
                                        <div  className={ "Customtooltip"}>

                                        {rowData.extendCount ? rowData.extendCount : 0}

                                        {
                                          rowData?.extendTimeStamp?.length ? 
                                          <div class="Extendtooltiptext">{
                                            rowData?.extendTimeStamp.map((stamp,index) => {

                                              return(
                                                <div style={{display:"flex",color:"white",padding:"5px"}}>
                                                    <div>{index + 1}. {moment.tz(stamp.startTime,"UTC").format('MM/DD/YYYY HH:mm')}</div>

                                                      <div style={{paddingLeft:"5px",paddingRight:"5px"}}>
                                                        -
                                                      </div>
                                                    <div>{moment.tz(stamp.endTime,"UTC").format('MM/DD/YYYY HH:mm')}</div>
                                                   
                                                  </div>
                                              )
                                            })
                                          }</div>
                                          : " "
                                        }
                                        </div>
                                      </TableColumn>
                                      <TableColumn className="quizTableColumn quizTableHeaderActionColumn">
                                    
                                        <Button
                                          className="buttonBorder buttonNotification"
                                          flat
                                          onClick={() =>  releaseLocks(rowData,index)}
                                        >
                                          Release Locks
                                        </Button>
                                        <Button
                                          className="buttonBorder buttonNotification"
                                          flat
                                          onClick={() =>  handleExtendDuedate(rowData,index)}
                                        >
                                          Extend Due Date
                                        </Button>
                                        {
                                          questionShowed.length > 0 && rowData.quiz_id === questionDataQuizId?
                                            <CSVLink style={{ marginLeft: 15 }} onClick={() =>  getAllQuestionsShowed(rowData,index)}  filename={`Questions Showed - ${rowData.quiz_id}${(currentUserId && currentUserId !== '') ? `_${currentUserId}`:'' }.csv`} data={questionShowed} headers={rowData.quiz_type == 1 ? csvTestHeader : csvHeader } >
                                                <Button primary raised style={{ marginLeft: 15 }} disabled={!(questionShowed.length > 0)}>Download Question data</Button>
                                            </CSVLink> : 
                                              <Button
                                                className="buttonBorder buttonNotification"
                                                flat
                                                onClick={() =>  getAllQuestionsShowed(rowData,index)}
                                              >
                                                Fetch Question Showed Data
                                              </Button>
                                        }
                                      </TableColumn>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </DataTable>
                              <Cell style={{display:"flex",justifyContent:"flex-end",marginLeft:"50%"}}>
                                <TablePagination
                                  rowsPerPageItems={[20,50,100,200]}
                                  defaultRowsPerPage={20}
                                  rows={rows}
                                  rowsPerPageLabel=""
                                  onPagination={quizHandlePagination}
                                />
                              </Cell>
                        
                            </Cell>
                          </Grid>
                        </Cell>
                      </Grid>
                  : null
                    }
                </Grid>
                {dueDatePage ? 
                         <div>
                          <DialogContainer
                            id="navigation-drawer-demo"
                            aria-label="Navigation Drawer Demo"
                            visible={dueDatePage}
                            fullPage
                            focusOnMount={false}           
                            onHide={updateVisibleHide}
                          >
                          <div>
                            {' '}

                            <Button  icon onClick={updateVisibleHide}>
                              close
                            </Button>
                          
                          </div>

                        
                          <div style={{width:"700px",marginLeft: "25%"}}>
                          <h3>{dueDatePage === true ? "Student Edit Window" : "Add Student Window"  }</h3>
                        <Grid style={{width:'100%'}}>
                            <Cell size={12} phoneSize={4} tabletSize={8}>
                            <Autocomplete
                              id="studentIDSearch"
                              label="User ID"
                              placeholder="User ID"
                              data={currentUserId}
                              value={currentUserId}
                              disabled={true}
                            />
                            </Cell><br/>
                            <Cell size={6} phoneSize={4} tabletSize={8}>
                            <DatePicker
                                    id="sstartDate"
                                    label="Start Date"
                                    displayMode="portrait"
                                    value={isValidDate(assignStartDate) ? assignStartDate : ""}
                                    onChange={handleStudentStartDate}


                            />
                            </Cell>
                            <Cell size={6} phoneSize={4} tabletSize={8}>
                            <TimePicker
                                    id="sstartTime"
                                    label="Start Time"
                                    displayMode="portrait"
                                    value={isValidDate(assignStartDate) ? assignStartDate : ''}
                                    onChange={handleStudentStartDate}

                            />  
                            </Cell>
                            <Cell size={6} phoneSize={4} tabletSize={8}>
                            
                            <DatePicker
                                    id="endDate"
                                    label="End Date"
                                    displayMode="portrait"
                                    value={isValidDate(assignEndDate) ? assignEndDate : ''}
                                    onChange={handleStudentEndDate}
                            />
                            </Cell>
                            <Cell size={6} phoneSize={4} tabletSize={8}>
                                <TimePicker
                                    id="endTime"
                                    label="End Time"
                                    displayMode="portrait"
                                    value={isValidDate(assignEndDate) ? assignEndDate : ''}
                                    onChange={handleStudentEndDate}

                                />
                            </Cell>
                            <Cell size={4} phoneSize={4} tabletSize={8}>
                            {loading === true ? 
                                <LoadingSpinner /> : ( 
                                <div>
                                  <Button
                                raised
                                primary
                                style={{marginRight:'10px'}}
                                className="buttonColour"
                                onClick={studentQuizDetails ? updateStudentDetails : saveStudentQuizTime}>
                                  {studentQuizDetails ? "Update" : "Save"}
                                </Button> 
                              
                                &nbsp;&nbsp;&nbsp;
                                <Button flat
                                    secondary
                                    swapTheming
                                    onClick={updateVisibleHide}> close</Button>
                                    </div>
                                )}
                            </Cell>
                            </Grid>
                            </div>

                          </DialogContainer>
                         </div> : null
                         }
            </SecureShow>
    
};

export default LoginAttemptPage;